import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "trigger"];
  static classes = ["visible", "hidden"];

  show() {
    this.contentTargets.forEach((contentTarget) => {
      contentTarget.classList.remove(...this.hiddenClasses);
      contentTarget.classList.add(...this.visibleClasses);
    });
  }

  hide(event) {
    if (
      this.contentTargets.some((contentTarget) =>
        contentTarget.contains(event.target),
      ) ||
      this.triggerTargets.some((triggerTarget) =>
        triggerTarget.contains(event.target),
      )
    )
      return;

    this.contentTargets.forEach((contentTarget) => {
      contentTarget.classList.remove(...this.visibleClasses);
      contentTarget.classList.add(...this.hiddenClasses);
    });
  }
}
